import { render, staticRenderFns } from "./program-media-block.html?vue&type=template&id=60919d09&scoped=true&"
import script from "./program-media-block.vue?vue&type=script&lang=ts&"
export * from "./program-media-block.vue?vue&type=script&lang=ts&"
import style0 from "./program-media-block.scss?vue&type=style&index=0&id=60919d09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60919d09",
  null
  
)

export default component.exports